export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q03_a.06052a84.png";